module.exports = __webpack_public_path__ + "static/media/transfers.7244685c.svg";